module.exports = __webpack_public_path__ + "img/17341841.53352cf3.png";